import '@mdi/font/css/materialdesignicons.min.css'

import FomanticUI from 'vue-fomantic-ui'
import 'fomantic-ui-css/semantic.min.css'

import './assets/css/main.scss'

import { createApp } from 'vue'

import App from './App.vue'
import router from './plugins/router'
import pinia from './plugins/pinia'
import initSentry from './plugins/sentry'

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(FomanticUI)

initSentry(app, router)

app.mount('#app')
